import dayjs from 'dayjs';

export const getRoomStatus = (room, reservations, currentDate = dayjs()) => {
  const todayReservations = reservations.filter((r) => {
    const checkIn = dayjs(r.checkInDate || r.checkinDate);
    const checkOut = dayjs(r.checkOutDate || r.checkoutDate);
    return currentDate.isBetween(checkIn, checkOut, 'day', '[]');
  });

  if (todayReservations.length === 0) return 'vacant';

  const active = todayReservations[0];
  const checkIn = dayjs(active.checkInDate || active.checkinDate);
  const checkOut = dayjs(active.checkOutDate || active.checkoutDate);

  if (checkIn.isSame(currentDate, 'day')) return 'arriving';
  if (checkOut.isSame(currentDate, 'day')) return 'departing';
  return 'occupied';
};
